import { apiPath } from '../../constants';
import { addSuccessMessage }  from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PROFILES_POST_REQUEST = 'POST_PROFILES_REQUEST';
export const PROFILES_POST_FAILURE = 'POST_PROFILES_FAILURE';
export const PROFILES_POST_SUCCESS = 'POST_PROFILES_SUCCESS';

export const postProfile = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.PROFILES.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSuccess(response.data));
                dispatch(addSuccessMessage('Profile successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {
        type: PROFILES_POST_REQUEST,
    }
};

const postFailure = error => {
    return {
        type: PROFILES_POST_FAILURE,
        error,
    }
};

const postSuccess = profile => {
    return {
        type: PROFILES_POST_SUCCESS,
        profile,
    }
};